import { FETCH_TRAINER_APPLY, FETCH_COACH } from './types';

export default {
    [FETCH_TRAINER_APPLY](state, payload) {
        state.trainer_apply = payload;
    },
    [FETCH_COACH](state, payload) {
        state.coach = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer_apply/mutations.js